"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jquery = _interopRequireDefault(require("jquery"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Confetti = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Confetti, _React$Component);
  function Confetti() {
    var _this;
    _classCallCheck(this, Confetti);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Confetti, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "makeConfetti", function () {
      // globals
      var canvas;
      var ctx;
      var W;
      var H;
      var mp = 150; // max particles
      var particles = [];
      var angle = 0;
      var tiltAngle = 0; // eslint-disable-line
      var confettiActive = true;
      var animationComplete = true;
      var reactivationTimerHandler; // eslint-disable-line
      var animationHandler; // eslint-disable-line

      // objects
      var particleColors = {
        colorOptions: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson'],
        colorIndex: 0,
        colorIncrementer: 0,
        colorThreshold: 10,
        getColor: function getColor() {
          if (this.colorIncrementer >= 10) {
            this.colorIncrementer = 0;
            this.colorIndex++;
            if (this.colorIndex >= this.colorOptions.length) {
              this.colorIndex = 0;
            }
          }
          this.colorIncrementer++;
          return this.colorOptions[this.colorIndex];
        }
      };
      function ConfettiParticle(color) {
        this.x = Math.random() * W; // x-coordinate
        this.y = Math.random() * H - H; // y-coordinate
        this.r = RandomFromTo(10, 30); // radius;
        this.d = Math.random() * mp + 10; // density;
        this.color = color;
        this.tilt = Math.floor(Math.random() * 10) - 10;
        this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
        this.tiltAngle = 0;

        // eslint-disable-next-line
        this.draw = function () {
          ctx.beginPath();
          ctx.lineWidth = this.r / 2;
          ctx.strokeStyle = this.color;
          ctx.moveTo(this.x + this.tilt + this.r / 4, this.y);
          ctx.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4);
          return ctx.stroke();
        };
      }
      (0, _jquery["default"])(document).ready(function () {
        SetGlobals();
        InitializeConfetti();
        (0, _jquery["default"])(window).resize(function () {
          W = window.innerWidth;
          H = window.innerHeight;
          canvas.width = W;
          canvas.height = H;
        });
      });
      function SetGlobals() {
        canvas = document.getElementById('confetti');
        ctx = canvas.getContext('2d');
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;
      }
      function InitializeConfetti() {
        particles = [];
        animationComplete = false;
        for (var i = 0; i < mp; i++) {
          var particleColor = particleColors.getColor();
          particles.push(new ConfettiParticle(particleColor));
        }
        StartConfetti();
      }
      function Draw() {
        ctx.clearRect(0, 0, W, H);
        var results = [];
        for (var i = 0; i < mp; i++) {
          // eslint-disable-next-line
          (function (j) {
            results.push(particles[j].draw());
          })(i);
        }
        Update();
        return results;
      }
      function RandomFromTo(from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
      }
      function Update() {
        var remainingFlakes = 0;
        var particle;
        angle += 0.01;
        tiltAngle += 0.1;
        for (var i = 0; i < mp; i++) {
          particle = particles[i];
          if (animationComplete) return;
          if (!confettiActive && particle.y < -15) {
            particle.y = H + 100;
            continue;
          }
          stepParticle(particle, i);
          if (particle.y <= H) {
            remainingFlakes++;
          }
          CheckForReposition(particle, i);
        }
        if (remainingFlakes === 0) {
          StopConfetti();
        }
      }
      function CheckForReposition(particle, index) {
        if ((particle.x > W + 20 || particle.x < -20 || particle.y > H) && confettiActive) {
          if (index % 5 > 0 || index % 2 === 0) {
            // 66.67% of the flakes
            repositionParticle(particle, Math.random() * W, -10, Math.floor(Math.random() * 10) - 20);
          } else if (Math.sin(angle) > 0) {
            // Enter from the left
            repositionParticle(particle, -20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
          } else {
            // Enter from the right
            repositionParticle(particle, W + 20, Math.random() * H, Math.floor(Math.random() * 10) - 20);
          }
        }
      }
      function stepParticle(particle, particleIndex) {
        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(angle + particle.d) + 3 + particle.r / 2) / 2;
        particle.x += Math.sin(angle);
        particle.tilt = Math.sin(particle.tiltAngle - particleIndex / 3) * 15;
      }
      function repositionParticle(particle, xCoordinate, yCoordinate, tilt) {
        particle.x = xCoordinate;
        particle.y = yCoordinate;
        particle.tilt = tilt;
      }
      function StartConfetti() {
        W = window.innerWidth;
        H = window.innerHeight;
        canvas.width = W;
        canvas.height = H;
        (function animloop() {
          if (animationComplete) return null;
          animationHandler = window.requestAnimationFrame(animloop);
          return Draw();
        })();
      }

      /*
      function ClearTimers() {
          clearTimeout(reactivationTimerHandler);
          clearTimeout(animationHandler);
      }
      */

      function StopConfetti() {
        animationComplete = true;
        if (ctx === undefined) return;
        ctx.clearRect(0, 0, W, H);
      }
    });
    return _this;
  }
  _createClass(Confetti, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.makeConfetti();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("canvas", {
        className: _style["default"].fullscreen,
        style: {
          position: this.props.positionOverride
        },
        id: "confetti"
      });
    }
  }]);
  return Confetti;
}(_react["default"].Component);
_defineProperty(Confetti, "propTypes", {
  positionOverride: _propTypes["default"].string
});
_defineProperty(Confetti, "defaultProps", {
  positionOverride: 'fixed'
});